import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { getProdutosAtivosFromToken } from "../utils/produtosRevenda";

const Layout = ({ userName, onLogout }) => {
  const produtosAtivos = useMemo(
    () => getProdutosAtivosFromToken(sessionStorage.getItem("token")),
    // reavalia quando o token muda no storage (login)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userName]
  );

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-[#0b1220] dark:via-[#0f172a] dark:to-[#020617]">
      <Sidebar userName={userName} onLogout={onLogout} produtosAtivos={produtosAtivos} />

      <div className="flex-1 flex flex-col overflow-hidden">

        <main className="flex-1 overflow-x-hidden overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
